// `breeze-purchase` event listener
window.addEventListener('breeze-pay-now', (event) => {

  let params = {};

  try {
    const stored = localStorage.getItem("breeze_payment_context");

    if (stored) {
      params = JSON.parse(stored);
    }
  } catch (e) {
    console.error("Error retrieving payment context:", e);
  }

  // Build items array safely
  const ctItems = (params.items || []).map(item => ({
    'item_id': item.id,
    'item_name': item.name,
    'item_price': item.price,
    'item_quantity': item.quantity
  }));

  window.clevertap.event.push("payment-started", {
    'Amount': String(params.totalPrice),
    'Payment mode': params.paymentMode || '',
    'Order Id': params.shopOrderId || '',
    'gateway': params.gatewayOrderId || '',
    'customer name': params.userDetails?.name || '',
    'customer email': params.userDetails?.email || '',
    'customer phoneNumber': params.userDetails?.phone || '',
    'shipping region': params.userDetails?.state || '',
    'shipping city': params.userDetails?.city || '',
    'shipping pincode': params.userDetails?.postalCode || '',
    'shipping country': params.userDetails?.countryCode || '',
    'shipping charge': params.shippingCharge || 0,
    'total discount': params.totalDiscount || '',
    'Discount name': params.discountName || '',
    'Currency': params.currency || 'INR',
    'Items count': params.items?.length || 0,
    'CT Source': 'Web',
    'Items': ctItems
  });

});
// window.addEventListener("breeze-purchase", (event) => {
//   const eventData = event.detail;
//   breezePurchase(eventData);
// });

// function breezePurchase(payload) {
//   try {
//     merchantPurchaseCustomCode(payload.data);
//   } catch (e) {
//     console.error("Error in triggering merchant's purchase script: ", e);
//   }
// }

// function merchantPurchaseCustomCode(params) {
//   try {
//     if (window.clevertap && typeof window.clevertap.event !== 'undefined') {
//       const ctItems = params.items.map((item) => ({
//         'Product Name': item.name,
//         'Product Id': String(item.id),
//         'Variant': String(item.variant),
//         'Price': item.price,
//         'Quantity': item.quantity,
//         'Image url': item.imageUrl || null,
//         'Currency': item.currency
//       }));

//       window.clevertap.event.push("Charged", {
//         'Amount': String(params.totalPrice),
//         'Payment mode': params.paymentMode || '',
//         'Order Id': params.shopOrderId || '',
//         'gateway': params.gatewayOrderId || '',
//         'customer name': params.userDetails?.name || '',
//         'customer email': params.userDetails?.email || '',
//         'customer phoneNumber': params.userDetails?.phone || '',
//         'shipping region': params.userDetails?.state || '',
//         'shipping city': params.userDetails?.city || '',
//         'shipping pincode': params.userDetails?.postalCode || '',
//         'shipping country': params.userDetails?.countryCode || '',
//         'shipping charge': params.shippingCharge || 0,
//         'total discount': params.totalDiscount || '',
//         'Discount name': params.discountName || '',
//         'Currency': params.currency || 'INR',
//         'Items count': params.items.length,
//         'CT Source': 'Web',
//         'Items': ctItems
//       });
//     } else {
//       console.warn("CleverTap is not available on window.");
//     }
//   } catch (e) {
//     console.error("Error in CleverTap event push: ", e);
//   }
// }


// ----------------- START BEGIN_CHECKOUT SCRIPT ------------------------------
// `breeze-initiate-checkout` event listener
window.addEventListener("breeze-initiate-checkout", (event) => {
  const eventData = event.detail;
  breezeInitiateCheckout(eventData);
});
// This function will be invoked by breeze after begin checkout
function breezeInitiateCheckout(payload) {
  try {
    console.log("started cgecjiyt>>",payload.data)
    
    merchantInitiateCheckoutCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants initiate checkout script : ", e);
  }
}
// merchant script for `begin_checkout` will be pasted here
function merchantInitiateCheckoutCustomCode(params) {
 // ---------------- CLEVERTAP START CHECKOUT EVENT CODE START ----------------
try {
  if (window.clevertap && typeof window.clevertap.event !== 'undefined') {
    // Initialize the event properties object
    const eventProperties = {
      'total': String(params.totalPrice),
      'currency': String(params.currency || 'INR'),
      'coupon': String(params.coupon || ''),
      'value': String(params.totalPrice),
      'landing_page': String(window.location.href),
      'origin_referrer': String(document.referrer),
      'utm_source': String(new URLSearchParams(window.location.search).get('utm_source') || ''),
      'utm_medium': String(new URLSearchParams(window.location.search).get('utm_medium') || ''),
      'utm_campaign': String(new URLSearchParams(window.location.search).get('utm_campaign') || ''),
      'utm_term': String(new URLSearchParams(window.location.search).get('utm_term') || ''),
      'utm_content': String(new URLSearchParams(window.location.search).get('utm_content') || ''),
      'email': String(params.userDetails?.email || ''),
      'phone': String(params.userDetails?.phone || ''),
      'address': String(`${params.userDetails?.address || ''}, ${params.userDetails?.city || ''}, ${params.userDetails?.state || ''}, ${params.userDetails?.postalCode || ''}, ${params.userDetails?.countryCode || ''}`),
      'total_quantity': String(params.items.reduce((sum, item) => sum + item.quantity, 0)),
      'source': 'breeze'
    };

    // Add individual item fields to the event properties
    params.items.forEach((item, index) => {
      eventProperties[`item_${index + 1}_id`] = String(item.id);
      eventProperties[`item_${index + 1}_name`] = String(item.name);
      eventProperties[`item_${index + 1}_price`] = String(item.price);
      eventProperties[`item_${index + 1}_quantity`] = String(item.quantity);
      eventProperties[`item_${index + 1}_currency`] = String(item.currency);
      eventProperties[`item_${index + 1}_size`] = item.size ? String(item.size) : '';
      eventProperties[`item_${index + 1}_title`] = item.title ? String(item.title) : '';
    });

    // Push the event with the constructed properties
    window.clevertap.event.push("Started_Checkout_JP", eventProperties);
  } else {
    console.warn("CleverTap is not available on window.");
  }
} catch (e) {
  console.error("Error in CleverTap event push: ", e);
}

// ---------------- CLEVERTAP START CHECKOUT EVENT CODE END ----------------

  // ---------------- CLEVERTAP BEGIN CHECKOUT EVENT CODE END ----------------
}

// ----------------- END BEGIN_CHECKOUT SCRIPT --------------------------------

// ----------------- START ADD_PAYMENT_INFO SCRIPT ----------------------------
// `breeze-add-payment-info` event listener
window.addEventListener("breeze-add-payment-info", (event) => {
  const eventData = event.detail;
  breezeAddPaymentInfo(eventData);
});
// This function will be invoked by breeze after add payment info
function breezeAddPaymentInfo(payload) {
  try {
    merchantAddPaymentInfoCustomCode(payload.data);
  } catch (e) {
    console.log("Error in triggering merchants add Payment info script : ", e);
  }
}
// merchant script for `add_payment_info` will be pasted here
function merchantAddPaymentInfoCustomCode(params) {
// with the exception of one of Identity, Email, or FBID
// each of the following fields is optional
console.log("pay now trihhered")
  try {
    if (params) {
      localStorage.setItem(
        "breeze_payment_context",
        JSON.stringify(params)
      );
    }
  } catch (e) {
    console.error("Error storing payment context:", e);
  }
  window.clevertap.onUserLogin.push({
      "Site": {
        "Name": params.userDetails?.name || '',
        "Identity": "+91"+String(params.userDetails?.phone),
        "Email": params.userDetails?.email || '',
        "Phone": "+91"+params.userDetails?.phone || '',
        "DOB": new Date(), // Add if date of birth is available
        "MSG-email": false,
        "MSG-push": true,
        "MSG-sms": true,
        "MSG-whatsapp": true
      }
    });
 // ---------------- CLEVERTAP ADD PAYMENT EVENT CODE START ----------------
try {
  if (window.clevertap && typeof window.clevertap.event !== 'undefined') {
    // Initialize the event properties object
    const eventProperties = {
      'total': String(params.totalPrice),
      'currency': String(params.currency || 'INR'),
      'coupon': String(params.coupon || ''),
      'value': String(params.totalPrice),
      'landing_page': String(window.location.href),
      'origin_referrer': String(document.referrer),
      'utm_source': String(new URLSearchParams(window.location.search).get('utm_source') || ''),
      'utm_medium': String(new URLSearchParams(window.location.search).get('utm_medium') || ''),
      'utm_campaign': String(new URLSearchParams(window.location.search).get('utm_campaign') || ''),
      'utm_term': String(new URLSearchParams(window.location.search).get('utm_term') || ''),
      'utm_content': String(new URLSearchParams(window.location.search).get('utm_content') || ''),
      'email': String(params.userDetails?.email || ''),
      'phone': String(params.userDetails?.phone || ''),
      'address': String(`${params.userDetails?.address || ''}, ${params.userDetails?.city || ''}, ${params.userDetails?.state || ''}, ${params.userDetails?.postalCode || ''}, ${params.userDetails?.countryCode || ''}`),
      'total_quantity': String(params.items.reduce((sum, item) => sum + item.quantity, 0))
    };

    // Add individual item fields to the event properties
    params.items.forEach((item, index) => {
      eventProperties[`item_${index + 1}_id`] = String(item.id);
      eventProperties[`item_${index + 1}_name`] = String(item.name);
      eventProperties[`item_${index + 1}_price`] = String(item.price);
      eventProperties[`item_${index + 1}_quantity`] = String(item.quantity);
      eventProperties[`item_${index + 1}_currency`] = String(item.currency);
      eventProperties[`item_${index + 1}_size`] = item.size ? String(item.size) : '';
      eventProperties[`item_${index + 1}_title`] = item.title ? String(item.title) : '';
    });

    // Push the event with the constructed properties
    window.clevertap.event.push("Payment_Method_Selected_JP", eventProperties);
  } else {
    console.warn("CleverTap is not available on window.");
  }
} catch (e) {
  console.error("Error in CleverTap event push: ", e);
}


// ---------------- CLEVERTAP ADD PAYMENT EVENT CODE END ----------------


}

// ----------------- START MULTIPASS LOGIN SCRIPT ------------------------------

/**
 * Multipass Login Integration for Breeze
 * 
 * This script checks for 'bzLtk' query parameter containing JWT token
 * and automatically generates Shopify multipass login URL.
 * 
 * Usage: Add ?bzLtk=<jwt_token> to any Shopify page URL
 */

(function() {
  'use strict';

  const BREEZE_API_BASE = 'https://api.breezesdk.store';
  
  /**
   * Get query parameter from URL
   */
  function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  /**
   * Remove query parameter from URL without reloading
   */
  function removeQueryParam(param) {
    const url = new URL(window.location.href);
    url.searchParams.delete(param);
    window.history.replaceState({}, document.title, url.toString());
  }

  /**
   * Decode JWT token to get customer data
   */
  function decodeJWT(token) {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (e) {
      console.error('[Breeze Multipass] Failed to decode JWT:', e);
      return null;
    }
  }


  /**
   * Generate multipass URL using Breeze API
   */
  async function generateMultipassUrl(jwtToken, customerData) {
    const shopUrl = "https://styleup-store-india.myshopify.com"
    
    const requestBody = {
      name: customerData.name || 'Customer',
      emailAddress: customerData.emailAddress || customerData.email,
      returnPlatformCredentials: true,
      shopUrl: shopUrl  // Required: backend reads shopUrl from body, not headers
    };

    console.log('[Breeze Multipass] Generating multipass URL for:', customerData.emailAddress);

    const response = await fetch(`${BREEZE_API_BASE}/user`, {
      method: 'PATCH',
      headers: {
        'Authorization': `Bearer ${jwtToken}`,
        'Content-Type': 'application/json',
        'X-Shop-URL': shopUrl,
        'X-Request-Id': `multipass-${Date.now()}`,
        'X-Device-Id': `shopify-theme-${Date.now()}`
      },
      body: JSON.stringify(requestBody)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP ${response.status}`);
    }

    const data = await response.json();
    const multipassUrl = data.platformAuthCredentials?.loginUrl;

    if (!multipassUrl) {
      throw new Error('Multipass URL not returned from API');
    }

    return multipassUrl;
  }
function showRedirectCountdown(onComplete) {
  let seconds = 3;

  // Example toast (replace with your toast system)
  const toast = document.createElement('div');
  toast.style.position = 'fixed';
  toast.style.bottom = '20px';
  toast.style.right = '20px';
  toast.style.padding = '12px 16px';
  toast.style.background = '#000';
  toast.style.color = '#fff';
  toast.style.borderRadius = '8px';
  toast.style.zIndex = '9999';

  toast.innerText = `Redirecting in ${seconds}...`;
  document.body.appendChild(toast);

  const timer = setInterval(() => {
    seconds--;

    if (seconds > 0) {
      toast.innerText = `Redirecting in ${seconds}...`;
    } else {
      clearInterval(timer);
      toast.innerText = 'Redirecting...';

      setTimeout(() => {
        toast.remove();
        onComplete();
      }, 500);
    }

  }, 1000);
}
  /**
   * Main function to handle multipass login
   */
async function handleMultipassLogin() {
  const jwtToken = getQueryParam('bzLtk');

  // Only proceed if bzLtk query param is present
  if (!jwtToken) return;

  console.log('[Breeze Multipass] JWT token found');

  // Remove token immediately
  removeQueryParam('bzLtk');

  const customerData = decodeJWT(jwtToken);

  if (!customerData) {
    console.error('[Breeze Multipass] Invalid JWT token');
    return;
  }

  if (!customerData.emailAddress && !customerData.email) {
    console.error('[Breeze Multipass] Email missing');
    return;
  }

  try {

    // 👇 SHOW COUNTDOWN FIRST
    showRedirectCountdown(async () => {

      console.log('[Breeze Multipass] Generating login URL...');

      const multipassUrl =
        await generateMultipassUrl(jwtToken, customerData);

      console.log('[Breeze Multipass] Redirecting to Shopify...');

      window.location.href = multipassUrl;

    });

  } catch (error) {

    console.error('[Breeze Multipass] Login failed:', error);

    // Optional fallback
    // window.location.href = `${window.location.origin}/account/login`;

  }
}

  // Execute when DOM is ready
  // if (document.readyState === 'loading') {
  //   document.addEventListener('DOMContentLoaded', handleMultipassLogin);
  // } else {
    // DOM already loaded
    handleMultipassLogin();
  // }

})();

// ----------------- END MULTIPASS LOGIN SCRIPT ------------------------------
